import React from 'react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
export function FinalCTASection() {
  return <section className="py-24 bg-nav relative overflow-hidden" data-id="element-64">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-65"></div>

      <Container className="relative z-10 text-center" data-id="element-66">
        <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-6 font-heading uppercase tracking-tight" data-id="element-67">
          Ready to Get Started?
        </h2>

        <p className="text-xl md:text-2xl text-gray-300 mb-10 max-w-2xl mx-auto font-light" data-id="element-68">
          Try a One Week FREE Trial and see what training is like.
        </p>

        <div className="flex flex-col sm:flex-row gap-6 justify-center" data-id="element-69">
          <a href="#signup" className="w-full sm:w-auto" data-id="element-70">
            <Button variant="primary" size="lg" fullWidth className="text-lg py-4 shadow-xl shadow-red-900/30 whitespace-nowrap" data-id="element-71">
              Get One Week Free Trial
            </Button>
          </a>
          <a href="tel:8472128045" className="w-full sm:w-auto" data-id="element-72">
            <Button variant="secondary" size="lg" fullWidth className="text-lg py-4 whitespace-nowrap" data-id="element-73">
              Call (847) 212-8045
            </Button>
          </a>
        </div>
      </Container>
    </section>;
}